import React, { useEffect, useState } from "react";
import { useStores } from "../../../store";

export default function FilterPopup({ show, onClose, onApply }) {
  const { RecuiterStore } = useStores();
  const [filters, setFilters] = useState({
    jobTitle: RecuiterStore.appliedFor,
    appliedDate: RecuiterStore.appliedDate,
    totalScore: RecuiterStore.score,
    status: RecuiterStore.status,
    interviewType: RecuiterStore.interviewType,
    completionStatus: RecuiterStore.interviewType !== "" ? RecuiterStore.completionStatus : "",
  });

  useEffect(() => {
    setFilters({
      jobTitle: RecuiterStore.appliedFor,
      appliedDate: RecuiterStore.appliedDate,
      totalScore: RecuiterStore.score,
      status: RecuiterStore.status,
      interviewType: RecuiterStore.interviewType,
      completionStatus: RecuiterStore.interviewType !== "" ? RecuiterStore.completionStatus : "",
    });
  }, [show]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleApply = (e) => {
    // if all the filters are empty then alert the user
    e.preventDefault();

    if (
      filters.jobTitle === "" &&
      filters.appliedDate === "" &&
      filters.totalScore === "" &&
      filters.status === "" &&
      filters.interviewType === "" &&
      filters.completionStatus === ""
    ) {
      alert("Please select atleast one filter");
      return;
    }
    onApply(filters);
    onClose();
  };

  const checkIfEmpty = () => {
    // check if all the filters are empty or not
    return (
      filters.jobTitle === "" &&
      filters.appliedDate === "" &&
      filters.totalScore === "" &&
      filters.status === "" &&
      filters.interviewType === "" &&
      filters.completionStatus === ""
    );
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 flex justify-end bg-gray-500 backdrop-blur-sm bg-opacity-30 gil-reg ">
      <form
        className="bg-white absolute bottom-20 md:bottom-5 p-6  rounded   h-fit lg:w-96  mr-10 "
        onReset={() => {}}
      >
        <div className="flex gap-4 mb-4 items-center">
          <h2 className="text-2xl ">Filter Applicants</h2>
          {/* <p className=" text-lg w-full flex justify-end text-primary ">[Coming soon]</p> */}
          <button
            className="text-md hover:underline ml-auto text-primary w-fit flex justify-end pl-4"
            type="reset"
            onClick={() => {
              setFilters({
                jobTitle: "",
                appliedDate: "",
                totalScore: "",
                status: "",
                interviewType: "",
                completionStatus: "",
              });
              RecuiterStore.resetFilter();
              onClose();
            }}
          >
            Reset
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-1">
          <div className="mb-4">
            <label className="block mb-1">Applied for</label>
            <input
              type="text"
              name="jobTitle"
              value={filters.jobTitle}
              onChange={handleChange}
              className="w-full p-2 border rounded"
              placeholder="All"
              onKeyDown={(event) => {
                if (
                  !/^[a-zA-Z]$/.test(event.key) &&
                  event.key !== "Backspace" &&
                  event.key !== " "
                ) {
                  event.preventDefault();
                }
              }}
            />
          </div>
          <div className="mb-4">
            <label className="block mb-1">Applied Date</label>
            <input
              type="date"
              name="appliedDate"
              value={filters.appliedDate}
              onChange={(e) => {
                const value = e.target.value;
                const [year, month, day] = value.split("-"); // Split the input into year, month, and day

                if (year.length > 4) {
                  // If the year exceeds 4 digits, truncate it
                  const truncatedYear = year.slice(0, 4);
                  const newValue = `${truncatedYear}-${month || "01"}-${
                    day || "01"
                  }`;
                  handleChange({
                    target: { name: e.target.name, value: newValue },
                  });
                } else {
                  handleChange(e); // Call the original handler if the year is valid
                }
              }}
              className="w-full p-2 border rounded"
              min={new Date("2020-01-01").toISOString().split("T")[0]}
              max={new Date().toISOString().split("T")[0]}
            />
          </div>

          <div className="mb-4">
            <label className="block mb-1">Total Score</label>
            <input
              type="text"
              name="totalScore"
              value={filters.totalScore}
              onChange={(e) => {
                // Allow only digits
                if (/^\d*$/.test(e.target.value)) {
                  handleChange(e);
                }
              }}
              className="w-full p-2 border rounded"
              placeholder="All Scores"
            />
          </div>
          <div className="mb-4">
            <label className="block mb-1">Status</label>
            <select
              name="status"
              value={filters.status}
              onChange={handleChange}
              className="w-full p-2 border rounded"
            >
              <option value="">All Status</option>
              <option value="2">Rejected</option>
              <option value="1">Shortlisted</option>
              <option value="3">Hired</option>
              {/* <option value="pending">Pending</option> */}
              <option value="0">On Hold</option>
              <option value="4">Proxy</option>
            </select>
          </div>
          <div className="mb-4">
            <label className="block mb-1">Type of Interview</label>
            <select
              name="interviewType"
              value={filters.interviewType}
              onChange={handleChange}
              className="w-full p-2 border rounded"
            >
              <option value="">Select Interview Type</option>
              <option value="technical">Technical</option>
              <option value="hr">HR</option>
              {/* <option value="Managerial">Managerial</option> */}
            </select>
          </div>
          {filters.interviewType !== "" && (
          <div className="mb-4">
            <label className="block mb-1">Completion Status</label>
            <select
              name="completionStatus"
              value={filters.completionStatus}
              onChange={handleChange}
              className="w-full p-2 border rounded"
            >
              <option value="">Select Completion Status</option>
              <option value="completed">Completed</option>
              <option value="pending">Pending</option>
              <option value="failed">Failed</option>
            </select>
          </div>
          )}
        </div>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleApply}
            className={`px-4 py-2 bg-primary text-white rounded ${
              checkIfEmpty() ? "cursor-not-allowed" : ""
            } hover:bg-primary hover:border-red-500`}
          >
            Apply
          </button>
        </div>
      </form>
    </div>
  );
}

// Exporting the second component as a named export

export function FilterPopupForJobs({ show, onClose, onApply }) {
  const [filters, setFilters] = useState({
    totalScore: "",
    status: "",
    hrInterview: false,
    technicalInterview: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFilters({ ...filters, [name]: checked });
    } else {
      setFilters({ ...filters, [name]: value });
    }
    console.log(filters);
  };

  const handleApply = () => {
    onApply(filters);
    onClose();
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-start justify-start backdrop-blur-sm bg-gray-500 bg-opacity-50 gil-reg">
      <div className="bg-white rounded  w-9/12 md:w-72 lg:w-96 mt-[30vh] md:mt-[10%] lg:mt-[4%] mx-auto p-5">
        <div className="flex flex-col gap-2 mb-3">
          <h2 className="text-lg md:text-xl">Filter Jobs</h2>
          <p className="text-sm md:text-base w-full flex justify-start text-primary">
            [Coming soon]
          </p>
        </div>
        <div className="grid grid-cols-1 gap-2">
          <div className="mb-2">
            <label className="block mb-1 text-xs md:text-sm">Total Score</label>
            <input
              type="number"
              name="totalScore"
              value={filters.totalScore}
              onChange={handleChange}
              className="w-full p-1 border rounded text-xs md:text-sm"
              placeholder="All Scores"
            />
          </div>
          <div className="mb-2">
            <label className="block mb-1 text-xs md:text-sm">Status</label>
            <select
              name="status"
              value={filters.status}
              onChange={handleChange}
              className="w-full p-1 border rounded text-xs md:text-sm"
            >
              <option value="">All Status</option>
              <option value="hired">Hired</option>
              <option value="rejected">Rejected</option>
              <option value="shortlisted">Shortlisted</option>
              <option value="pending">Pending</option>
              <option value="onhold">On Hold</option>
            </select>
          </div>
          <div className="mb-2">
            <label className="block mb-1 text-xs md:text-sm">
              Type of Interview
            </label>
            <div className="flex flex-col">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  name="technicalInterview"
                  checked={filters.technicalInterview}
                  onChange={handleChange}
                  className="form-checkbox"
                />
                <span className="ml-2 text-xs md:text-sm">Technical</span>
              </label>
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  name="hrInterview"
                  checked={filters.hrInterview}
                  onChange={handleChange}
                  className="form-checkbox"
                />
                <span className="ml-2 text-xs md:text-sm">HR</span>
              </label>
            </div>
          </div>
        </div>
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-2 py-1 bg-gray-200 rounded text-xs md:text-sm hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleApply}
            className="px-2 py-1 bg-primary text-white rounded text-xs md:text-sm hover:bg-primary hover:border-red-500"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
